import React, { Fragment, useMemo } from "react";
import { Box, Button, Container, Grid, Pagination } from "@mui/material";
import { scrollToTop } from "common/utils/scroll";
import { FlexBetween } from "components/flex-box";
import ProductCard1 from "components/product-cards/ProductCard1";
import { Span } from "components/Typography";
import { pcwEvent } from "common/constants/pcw-event";
import NothingToShow from "components/worth-it-builder/NothingToShow";
import { Product } from "modules/products/types";
import { useSearchPage } from "hooks";
import { useRouter } from "next/router";
import BestSellerSection from "pages-sections/home/BestSellerSection";
import { RecentlyViewedProducts } from "pages-sections/home/RecentlyViewedProducts";
import LatestProductsSection from "pages-sections/home/LatestProductsSection";
import LatestBuildsSection from "pages-sections/home/LatestBuildsSection";
import PackageList from "pages-sections/home/PackageList";
import PoweredBuildSection from "pages-sections/home/PoweredBuildSection";

// ========================================================
type Props = {
  products?: Product[];
  totalProductsCount?: number;
  from?: number;
  to?: number;
  currentPage?: number;
  lastPage?: number;
  isShowFilter?: boolean;
  hasProducts?: boolean;
  isLoading?: boolean;
  onChangePage?: (newPageNum: number) => void;
};
// ========================================================

const ProductCard1List = ({
  products = [],
  totalProductsCount = 0,
  from = 1,
  to = 99999,
  lastPage = 1,
  currentPage = 1,
  isLoading,
  hasProducts,
  onChangePage,
}: Props) => {
  const { keyword } = useSearchPage();
  const { query, push } = useRouter();

  const productCounts = useMemo(() => {
    return products?.length;
  }, [products?.length]);

  const onChangePageInternal = (newPageNum: number = 1) => {
    scrollToTop();
    onChangePage(newPageNum);
  };

  const onHandleNavigateToNoKeywordSearch = () => {
    const { id, ...newQuery } = query;
    push(
      {
        pathname: `/product/search`,
        query: newQuery,
      },
      undefined,
      { shallow: true }
    );
  };

  if (productCounts <= 0 && !isLoading) {
    // retain old ui for ez revert
    // return (
    //   <Box sx={{ display: "grid", placeItems: "center" }}>
    //     <NothingToShow
    //       image={"/assets/images/kachi/kachi-nervous.png"}
    //       title={"0 results found"}
    //       subtitle={
    //         "Try adjusting the filters to refine your search and find the product you're looking for or,"
    //       }
    //       noBackground={true}
    //     />
    //     <Button
    //       variant="outlined"
    //       color="primary"
    //       onClick={onHandleNavigateToNoKeywordSearch}
    //       sx={{ width: "50%", mt: "-3rem", textAlign: "center" }}
    //     >{`Clear search keyword (${keyword})`}</Button>
    //   </Box>
    // );

    return (
      <Container
        sx={{
          mb: "3em",
          paddingX: "0 !important",
        }}
      >
        <PoweredBuildSection />
        <LatestBuildsSection />
        <BestSellerSection isLarge={true} />
        <RecentlyViewedProducts />
        {pcwEvent.isEventOnGoing ? null : <LatestProductsSection />}
      </Container>
    );
  }

  return (
    <Fragment>
      <Grid container spacing={1}>
        {products?.map((item, ind) => (
          <Grid item sm={3} xs={6} lg={3} key={ind}>
            <ProductCard1 productData={item} />
          </Grid>
        ))}
      </Grid>
      {productCounts > 0 && totalProductsCount > 0 ? (
        <FlexBetween flexWrap="wrap" mt={4}>
          <Span color="grey.600">{`Showing ${from}-${to} of ${totalProductsCount} Products`}</Span>
          <Pagination
            color="primary"
            defaultPage={1}
            count={lastPage}
            variant="outlined"
            page={currentPage}
            onChange={(_, newPageNum) => onChangePageInternal(newPageNum)}
          />
        </FlexBetween>
      ) : null}
    </Fragment>
  );
};

export default ProductCard1List;
